import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { select, Store } from '@ngrx/store';
import { LoadUnloadTimeCatalogAction } from '../../../actions/single-catalogs.actions';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { filter, map, take } from 'rxjs/operators';
import { getOpenPlatformProducts } from '../../../selectors/products.selectors';
import { makeReference } from '@ordersnproducts/utils/mix-reference';

@Injectable()
export class LoadSingleCatalogsUnloadTime implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) =>
          products.find((product) => _safe(() => product.productCode.replace(/^0+/, '') === value, false)),
        ),
      )
      .subscribe((product) => {
        if (product) {
          this.store.dispatch(new LoadUnloadTimeCatalogAction());
        }
      });
  }
}

@Injectable()
export class LoadSingleCatalogsUnloadTimeMixRef implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(value, formGroup: UntypedFormGroup, form: ConfigurableFormComponent): void {
    this.store
      .pipe(
        select(getOpenPlatformProducts),
        filter((products) => !!value && !!products.length),
        take(1),
        map((products) => products.find((product) => makeReference(product) === value)),
      )
      .subscribe((product) => {
        const technicalProductCode = _safe(() => product.technicalProducts[0].technicalProductCode);
        if (technicalProductCode) {
          this.store.dispatch(new LoadUnloadTimeCatalogAction());
        }
      });
  }
}
